import {
  ReviewSerchBox,
} from './reviewSerchBoxStyle'
import SearchHeader from '../../header/bottomHeader/bottomHeaderRight/searchHeader';

const ReviewSerch = () => {
  return (
    <ReviewSerchBox>
      {/* <Form className="search-header" onSubmit={formik.handleSubmit}>
          <SearchInputBox className='seach-box'>
            <InputGroup>
              <InputGroupIcon className='search-icon'>
                <Image src={Search_icon} width="20px" height="20px" className="search-group-icon" />
              </InputGroupIcon>
              <FormControl
                type="text"
                placeholder="Org,City & State"
                id="location"
                maxLength={30}
                name="location"
                value={formik.values.location}
                onChange={formik.handleChange} />
              {formik.touched.location && formik.errors.location && (
                <div className="error">
                  <p>{formik.errors.location}</p>
                </div>
              )}
            </InputGroup>
            <InputGroup className="zipcode">
              <FormControl
                type="number"
                placeholder="Zip Code"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                maxLength={10}
                name="zipcode"
                value={formik.values.zipcode}
                onChange={formik.handleChange} />
              {formik.touched.zipcode && formik.errors.zipcode && (
                <div className="error">
                  <p>{formik.errors.zipcode}</p>
                </div>
              )}
            </InputGroup>
          </SearchInputBox>
          <Button variant="outline-success" type="submit">Search</Button>
        </Form>  */}
      <SearchHeader />
    </ReviewSerchBox>
  )
}

export default ReviewSerch
